import { INITIAL_PAGING } from '../redux';

export class PagingManager {
  constructor(fetchFunction, getPageableList, setList) {
    this.paramCache = {};
    this.fetchFunction = fetchFunction;
    this.getPageableList = getPageableList;
    this.setList = setList;
  }

  setPagedList = () => {
    this.setList(this.getPageableList().items);
  };

  getPaging = () => {
    return this.getPageableList().paging() || INITIAL_PAGING;
  };

  refresh = () => {
    const { page } = this.getPaging();
    this.goToPage(page);
  };

  fetch = async params => {
    this.paramCache = { ...params };
    await this.fetchFunction({ ...params });
    this.setPagedList();
  };

  goToPage = async page => {
    await this.fetchFunction({ ...this.paramCache, page });
    this.setPagedList();
  };

  next = async () => {
    const { page, totalPages } = this.getPaging();

    if (page < totalPages) {
      await this.goToPage(page + 1);
    }
  };

  previous = async () => {
    const { page } = this.getPaging();

    if (page > 1) {
      await this.goToPage(page - 1);
    }
  };

  sort = () => {};
}
